import React, { useEffect, useState } from 'react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(4 * 3600 + 58 * 60 + 44);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 bg-patriot-red text-white py-2 px-4 text-center font-bold text-sm md:text-base shadow-md" data-id="element-71">
      LIMITED TIME OFFER: Ends in{' '}
      <span className="font-mono bg-black/20 px-2 py-0.5 rounded ml-1" data-id="element-72">
        {formatTime(timeLeft)}
      </span>
    </div>;
}